export default class AccountSeats {
  constructor(
    public universal: { current: number; total: number } = {
      current: -1,
      total: -1,
    },
    public admin: { current: number; total: number } = {
      current: -1,
      total: -1,
    },
    public viewer: { current: number; total: number } = {
      current: -1,
      total: -1,
    },
    public integration: { current: number; total: number } = {
      current: -1,
      total: -1,
    },
    public isDevMode: boolean = false,
  ) {}

  // "Starter" plan has universal seats - "Advanced" and "Enterprise" plans have admin and viewer seats
  // For "Advanced" and "Enterprise" plans, if viewer seats are null they should not count towards seat limits

  public get isUniversalAccount(): boolean {
    return this.universal.total > 0 && this.admin.total <= 0 && this.viewer.total <= 0
  }

  public get isAdminOnlyAccount(): boolean {
    return this.admin.total > 0 && this.universal.total <= 0 && this.viewer.total <= 0
  }

  public get isAllLimitsReached(): boolean {
    if(this.isDevMode){
      return false
    }
    return this.allUsed >= this.allTotal
  }

  public get isAnyLimitReached(): boolean {
    if(this.isDevMode){
      return false
    }
    if(this.isUniversalAccount){
      return this.universal.current >= this.universal.total
    }
    if(this.isAdminOnlyAccount){
      return this.admin.total > 0 && this.admin.current >= this.admin.total
    }
    return (this.admin.total > 0 && this.admin.current >= this.admin.total) || (this.viewer.total > 0 && this.viewer.current >= this.viewer.total)
  }

  public get allTotal(): number {
    if(this.isDevMode){
      return 100
    }
    if(this.isUniversalAccount){
      return this.universal.total
    }
    if(this.isAdminOnlyAccount){
      return this.admin.total
    }
    return this.admin.total + this.viewer.total
  }
  
  public get allUsed(): number {
    if(this.isDevMode){
      return 0
    }
    if(this.isUniversalAccount){
      return this.universal.current
    }
    if(this.isAdminOnlyAccount){
      return this.admin.current
    }
    return this.admin.current + this.viewer.current
  }

  public get allRemaining(): number {
    if(this.isDevMode){
      return 100
    }
    return this.allTotal - this.allUsed
  }

  public get adminRemaining(): number {
    if(this.isDevMode){
      return 100
    }
    return this.admin.total - this.admin.current
  }

  public get universalRemaining(): number {
    if(this.isDevMode){
      return 100
    }
    return this.universal.total - this.universal.current
  }

  public get viewerRemaining(): number {
    if(this.isDevMode){
      return 100
    }
    return this.viewer.total - this.viewer.current
  }

  // Integration seats are a separate pool, not included in universal/admin/viewer totals
  public get integrationRemaining(): number {
    if(this.isDevMode){
      return 100
    }
    return this.integration.total - this.integration.current
  }

  // A total of 0 or less means the integration pool is not provisioned for this
  // account, which is not the same as the pool being full.
  public get isIntegrationLimitReached(): boolean {
    if(this.isDevMode){
      return false
    }
    return this.integration.total > 0 && this.integrationRemaining < 1
  }

  public static fromResponseObject(obj): AccountSeats {
    if (!obj) return new AccountSeats()

    return new AccountSeats(
      obj.universal ? obj.universal : { current: -1, total: -1 },
      obj.admin ? obj.admin : { current: -1, total: -1 },
      obj.viewer ? obj.viewer : { current: -1, total: -1 },
      obj.integration ? obj.integration : { current: -1, total: -1 },
    )
  }
}
